(function ($) {
    $(document).ready(function () {
        anchors();
    });

    jQuery(window).smartresize(function () {
        anchorsSlider();
    });

    function anchors() {
        var wrap = $('.anchors .wrap');
        if (wrap.length > 0) {
            wrap = wrap.eq(0);
            var items = wrap.find('a');
            items.each(function () {
                var item = $(this);
                var goTo = '#' + item.attr('data-scroll');
                if (false && $(goTo).length === 0) {
                    item.remove();
                } else {
                    item.click(function () {
                        var goTo = '#' + item.attr('data-scroll');
                        var top_part = $('.anchors').outerHeight();
                        var top = $(goTo).offset().top - top_part - 150;
                        $('html,body').stop().animate({scrollTop: top}, 500);
                        wrap.find('a').removeClass('active');
                        item.addClass('active');
                        if($(goTo).find('.slick-initialized').length > 0){
                            $(goTo).find('.slick-slide:not(.slick-cloned) a').eq(0).focus();
                        } else{
                            $(goTo).find('a,input[type!="hidden"]').eq(0).focus();
                        }
                    });
                }
            });
            anchorsSlider();
        }
        anchorsAddClass();
    }

    function anchorsAddClass() {
        var anchors = $('.anchors'),
            header = $('#header_wrapper');

        if (anchors.length > 0) {
            var headerHeight = header.height();
            var closestSection = null;
            jQuery('.section').each(function () {
                var s = jQuery(this),
                    paddingTxt = $('.section').eq(1).css('padding-bottom'),
                    padding = paddingTxt.replace('px', ''),
                    topPosition = s.offset().top - padding,
                    distance = topPosition - headerHeight - jQuery(document).scrollTop() - 1;
                if (distance <= 0) {
                    closestSection = s;
                }
            });
            if (closestSection !== null) {
                jQuery('.anchors .active').removeClass('active');
                jQuery('.anchors a[data-scroll="' + closestSection.attr('id') + '"]').addClass('active');
            }
        }
    }

    function anchorsSlider() {
        var main_wrap = $('.anchors .container');
        if (main_wrap.length > 0) {
            var wrap = main_wrap.find('.wrap');
            var wrap_width = wrap.width();
            var labels = wrap.find('.label');
            var labels_width = 0;
            if (!is_phone) {
                labels.each(function () {
                    labels_width = labels_width + $(this).outerWidth(true);
                });
                if (labels_width > wrap_width) {
                    main_wrap.addClass('slider_is_visible');
                    if (!wrap.hasClass('slick-initialized')) {
                        wrap.removeAttr('role').removeAttr('aria-label');

                        var arrows = main_wrap.find('.arrow');
                        wrap.on('init', function (){
                            arrows.each(function(){
                                if($(this).hasClass('slick-disabled')){
                                    $(this).attr('tabindex',-1);
                                }
                            });

                        });
                        //After change removed the focus to arrows and focus on next slide
                        wrap.on('beforeChange', function (event, slick, currentSlide, nextSlide){
                            arrows.blur();
                            var NextSlide = $(slick.$slides.get(nextSlide));
                            NextSlide.focus();
                        });

                        wrap.slick({
                            infinite: false,
                            variableWidth: true,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            arrows:true,
                            nextArrow: main_wrap.find('.next'),
                            prevArrow: main_wrap.find('.prev'),
                            rtl: $('html').attr('dir') == 'rtl'
                        });

                        arrows.each(function(){
                            $(this).on('click', function (){
                                if(!$(this).hasClass('slick-disabled')){
                                    $(this).siblings().removeAttr('tabindex');
                                } else {
                                    $(this).attr('tabindex',-1);
                                }
                            });
                        });


                    }
                } else {
                    main_wrap.removeClass('slider_is_visible');
                    if (wrap.hasClass('slick-initialized')) {

                        wrap.slick('unslick');
                    }
                }
            }
        }
    }
})(jQuery);

